import {
  Action,
  Category,
  ErrorAction,
  MethodologiesAction,
  MethodologiesList,
  MethodologiesState,
} from "./types";
import { Observable, of } from "rxjs";
import { catchError, mergeMap } from "rxjs/operators";
import { API_URL } from "./config";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";

const FETCH_METHODOLOGY_CATEGORIES_REQUESTED =
  "FETCH_METHODOLOGY_CATEGORIES_REQUESTED";
const FETCH_METHODOLOGY_CATEGORIES_SUCCESSFUL =
  "FETCH_METHODOLOGY_CATEGORIES_SUCCESSFUL";
const FETCH_METHODOLOGY_CATEGORIES_REJECTED =
  "FETCH_METHODOLOGY_CATEGORIES_REJECTED";
const FETCH_METHODOLOGIES_LIST_REQUESTED = "FETCH_METHODOLOGIES_LIST_REQUESTED";
const FETCH_METHODOLOGIES_LIST_SUCCESSFUL =
  "FETCH_METHODOLOGIES_LIST_SUCCESSFUL";
const FETCH_METHODOLOGIES_LIST_REJECTED = "FETCH_METHODOLOGIES_LIST_REJECTED";

export const fetchMethodologyCategories = (
  lang: string
): MethodologiesAction => ({
  type: FETCH_METHODOLOGY_CATEGORIES_REQUESTED,
  payload: { lang },
});

export const fetchMethodologyCategoriesSuccessful = (
  categories: Category[]
): MethodologiesAction => ({
  type: FETCH_METHODOLOGY_CATEGORIES_SUCCESSFUL,
  payload: { categories },
});

export const fetchMethodologyCategoriesRejected = (
  error: TypeError
): ErrorAction => ({
  type: FETCH_METHODOLOGY_CATEGORIES_REJECTED,
  error,
});

export const fetchMethodologiesList = (
  categoryId: number
): MethodologiesAction => ({
  type: FETCH_METHODOLOGIES_LIST_REQUESTED,
  payload: { categoryId },
});

export const fetchMethodologiesListSuccessful = (
  list: MethodologiesList
): MethodologiesAction => ({
  type: FETCH_METHODOLOGIES_LIST_SUCCESSFUL,
  payload: { list },
});

export const fetchMethodologiesListRejected = (
  error: TypeError
): ErrorAction => ({
  type: FETCH_METHODOLOGIES_LIST_REJECTED,
  error,
});

export default (
  state: MethodologiesState = {
    categories: [],
    list: null,
  },
  { type, payload }: MethodologiesAction
) => {
  switch (type) {
    case FETCH_METHODOLOGY_CATEGORIES_SUCCESSFUL:
      return {
        ...state,
        categories: payload.categories,
      };
    case FETCH_METHODOLOGIES_LIST_SUCCESSFUL:
      return {
        ...state,
        list: payload.list,
      };
    default:
      return state;
  }
};

export const fetchCategoriesEpic = (
  action$: Observable<MethodologiesAction>
): Observable<Action> =>
  action$.pipe(
    ofType(FETCH_METHODOLOGY_CATEGORIES_REQUESTED),
    mergeMap(({ payload: { lang } }) =>
      ajax.get(`${API_URL}/methodologies/?lang=${lang}`).pipe(
        mergeMap(({ response }) =>
          of(fetchMethodologyCategoriesSuccessful(response))
        ),
        catchError(error => of(fetchMethodologyCategoriesRejected(error)))
      )
    )
  );

export const fetchMethodologyListEpic = (
  action$: Observable<MethodologiesAction>
): Observable<Action> =>
  action$.pipe(
    ofType(FETCH_METHODOLOGIES_LIST_REQUESTED),
    mergeMap(({ payload: { categoryId } }) =>
      ajax.get(`${API_URL}/methodologies/${categoryId}/`).pipe(
        mergeMap(({ response }) =>
          of(fetchMethodologiesListSuccessful(response))
        ),
        catchError(error => of(fetchMethodologiesListRejected(error)))
      )
    )
  );
